import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["value", "onChange", "required", "justify", "parameterId", "max"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
import { InputCheckboxButtonList } from '@isyc-react/form/modules/input/option/checkbox';
import { useParameterTemplateReadQuery } from "./parameter-template-read.query";
const sep = ',';
export const InputParameterDefaultValues = props => {
  const {
      value: valueProp,
      onChange,
      required,
      justify,
      parameterId,
      max
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    data,
    loading,
    error
  } = useParameterTemplateReadQuery({
    variables: {
      id: parameterId
    }
  });
  const {
    labels,
    values
  } = React.useMemo(() => {
    const options = {
      labels: [],
      values: []
    };
    if (data && data.parameterTemplate_read && data.parameterTemplate_read.defaultValues) {
      data.parameterTemplate_read.defaultValues.filter(df => df !== null).forEach(df => {
        options.labels.push(df.text);
        options.values.push({
          checked: false,
          indeterminate: false,
          data: df
        });
      });
    }
    return options;
  }, [data]);
  const value = React.useMemo(() => {
    var _valueProp$split;
    const valueArray = (_valueProp$split = valueProp === null || valueProp === void 0 ? void 0 : valueProp.split(sep)) !== null && _valueProp$split !== void 0 ? _valueProp$split : [];
    const result = [];
    values.forEach(v => {
      const item = _objectSpread(_objectSpread({}, v), {}, {
        checked: v.data && valueProp ? valueArray.includes(v.data.code) : false
      });
      result.push(item);
    });
    return result;
  }, [values, valueProp]);

  // TODO error and improve loading

  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    size: "sm"
  }) : /*#__PURE__*/React.createElement(InputCheckboxButtonList, _extends({
    justify: justify,
    value: value,
    labels: labels,
    onChange: change => {
      const checked = change.filter(c => c.checked);
      onChange && onChange(checked.map(c => {
        var _c$data$code, _c$data;
        return (_c$data$code = (_c$data = c.data) === null || _c$data === void 0 ? void 0 : _c$data.code) !== null && _c$data$code !== void 0 ? _c$data$code : '';
      }).join(sep));
    },
    max: max
  }, rest)));
};